<template>
  <div class="trx-list">
    <div class="sticky" v-show="!isMobile">
      <div :class="{'scroll-table':true, 'two-line-filter':is2lines}">
        <table>
          <thead>
            <th :class="{'sortable':true, 'sort':sort.active ==='created'}"
              @click="sortTable('created')">
              {{ $t('consumer.transactions.date') }}
              <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
            </th>
            <th>{{ $t('consumer.transactions.providerId') }}</th>
            <th>{{ $t('consumer.transactions.company') }}</th>
            <th :class="{'sortable':true, 'sort':sort.active ==='rsvpId'}"
              @click="sortTable('rsvpId')">
              {{ $t('consumer.transactions.rsvpId') }}
              <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
            </th>
            <th :class="{'sortable':true, 'sort':sort.active ==='eventId'}"
              @click="sortTable('eventId')">
              {{ $t('consumer.transactions.invoiceId') }}
              <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
            </th>
            <th :class="{'sortable':true, 'sort':sort.active ==='isAsap'}"
              @click="sortTable('isAsap')">
              {{ $t('consumer.transactions.type') }}
              <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
            </th>
            <th>{{ $t('consumer.transactions.creditCard') }}</th>
            <th>{{ $t('consumer.transactions.bookedThrough') }}</th>
            <th>{{ $t('consumer.transactions.finalOffer') }}</th>
            <th>{{ $t('consumer.transactions.chargedAmount') }}</th>
            <th>{{ $t('consumer.transactions.promoUsed') }}</th>
            <th>{{ $t('consumer.transactions.status') }}</th>
            <th><i class="stripe-icon fab fa-stripe-s"></i></th>
          </thead>
          <tbody>
            <tr v-for="trx in transactions" v-show="transactions.length > 0">
              <td>{{ trx.date }}</td>
              <td>
                <a v-bind:href="'/#/provider/' + trx.providerId" target="_blank">{{ trx.providerId }}</a>
              </td>
              <td>{{ trx.company }}</td>
              <td>
                <a v-bind:href="'/#/reservation/' + trx.rsvpId" target="_blank" v-if="trx.rsvpId !== 0">{{ trx.rsvpId }}</a>
                <a v-bind:href="'/#/package/' + trx.pkgId" target="_blank" v-else>
                  {{ trx.pkgId }} <i class="fa fa-cube"></i>
                </a>
              </td>
              <td>
                <span v-if="trx.trxId !== '0'">{{ trx.trxId }}</span>
                <span v-else>--</span>
              </td>
              <td>
                <span v-if="trx.pkgId" class="package">PKG</span>
                <span :class="['rsvp-type', trx.type]" v-else>{{ trx.type }}</span>
              </td>
              <td>{{ trx.creditCard }}</td>
              <td class="bookedThrough">
                <span v-bind:class="['booked-label', trx.bookedThrough]">{{ trx.bookedThrough }}</span>
              </td>
              <td>{{ trx.finalOffer }}</td>
              <td>{{ trx.chargedAmount }}</td>
              <td>{{ trx.promoUsed }}</td>
              <td class="status">
                <span v-bind:class="['status-label', trx.statusLabel, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '']">{{ trx.statusLabel }}</span>
              </td>
              <td>
                <span v-if="trx.paymentURL === null">--</span>
                <a v-else :href="trx.paymentURL" target="_blank"><i class="fa fa-link"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div :class="{'scroll-table':true, 'two-line-filter':is2lines}" v-show="!isMobile">
      <table class="main-table">
        <thead>
          <th :class="{'sortable':true, 'sort':sort.active ==='created'}"
            @click="sortTable('created')">
            {{ $t('consumer.transactions.date') }}
            <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
          </th>
          <th>{{ $t('consumer.transactions.providerId') }}</th>
          <th>{{ $t('consumer.transactions.company') }}</th>
          <th :class="{'sortable':true, 'sort':sort.active ==='rsvpId'}"
            @click="sortTable('rsvpId')">
            {{ $t('consumer.transactions.rsvpId') }}
            <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
          </th>
          <th :class="{'sortable':true, 'sort':sort.active ==='eventId'}"
            @click="sortTable('eventId')">
            {{ $t('consumer.transactions.invoiceId') }}
            <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
          </th>
          <th :class="{'sortable':true, 'sort':sort.active ==='isAsap'}"
            @click="sortTable('isAsap')">
            {{ $t('consumer.transactions.type') }}
            <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
          </th>
          <th>{{ $t('consumer.transactions.creditCard') }}</th>
          <th>{{ $t('consumer.transactions.bookedThrough') }}</th>
          <th>{{ $t('consumer.transactions.finalOffer') }}</th>
          <th>{{ $t('consumer.transactions.chargedAmount') }}</th>
          <th>{{ $t('consumer.transactions.promoUsed') }}</th>
          <th>{{ $t('consumer.transactions.status') }}</th>
          <th><i class="stripe-icon fab fa-stripe-s"></i></th>
        </thead>
        <tbody>
          <tr v-for="trx in transactions" v-show="transactions.length > 0">
            <td>{{ trx.date }}</td>
            <td>
              <a v-bind:href="'/#/provider/' + trx.providerId" target="_blank">{{ trx.providerId }}</a>
            </td>
            <td>{{ trx.company }}</td>
            <td>
              <a v-bind:href="'/#/reservation/' + trx.rsvpId" target="_blank" v-if="trx.rsvpId !== 0">{{ trx.rsvpId }}</a>
              <a v-bind:href="'/#/package/' + trx.pkgId" target="_blank" v-else>
                {{ trx.pkgId }} <i class="fa fa-cube"></i>
              </a>
            </td>
            <td>
              <span v-if="trx.trxId !== '0'">{{ trx.trxId }}</span>
              <span v-else>--</span>
            </td>
            <td>
              <span v-if="trx.pkgId" class="package">PKG</span>
              <span :class="['rsvp-type', trx.type]" v-else>{{ trx.type }}</span>
            </td>
            <td>{{ trx.creditCard }}</td>
            <td class="bookedThrough">
              <span v-bind:class="['booked-label', trx.bookedThrough]">{{ trx.bookedThrough }}</span>
            </td>
            <td>{{ trx.finalOffer }}</td>
            <td>{{ trx.chargedAmount }}</td>
            <td>{{ trx.promoUsed }}</td>
            <td class="status">
              <span v-bind:class="['status-label', trx.statusLabel]">{{ trx.statusLabel }}</span>
            </td>
            <td>
              <span v-if="trx.paymentURL === null">--</span>
              <a v-else :href="trx.paymentURL" target="_blank"><i class="fa fa-link"></i></a>
            </td>
          </tr>

          <tr v-show="loading">
            <td colspan="13" class="table-block">
                <i class="fa fa-circle-notch fa-spin"></i>
                {{ $t('consumer.transactions.loading') }}
            </td>
          </tr>

          <tr>
            <td colspan="13" class="table-block" v-show="transactions.length === 0 && !loading">
              {{ $t('consumer.transactions.emptyState') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cards" v-show="isMobile">
      <div class="card" v-show="loading">
        <i class="fa fa-circle-notch fa-spin"></i>
        {{ $t('consumer.transactions.loading') }}
      </div>

      <div class="card" v-show="transactions.length === 0 && !loading">
        {{ $t('consumer.transactions.emptyState') }}
      </div>
      <div class="card" v-for="trx in transactions" v-show="transactions.length > 0" :key="trx.id">
        <div class="card-header">
          <div class="time">
            {{trx.date}}
          </div>
          <div class="amount">
            <span v-if="trx.paymentURL === null">{{ trx.chargedAmount }}</span>
            <a v-else :href="trx.paymentURL" target="_blank">{{ trx.chargedAmount }} <i class="fa fa-link"></i></a>
          </div>
        </div>
        <div class="title pkg-div">
          <div class="pkg-type">
            <div>
              <span v-if="trx.pkgId" class="package">PKG</span>
              <span :class="['rsvp-type', trx.type]" v-else>{{ trx.type }}</span>
            </div>
            <div>
              <span v-bind:class="['booked-label', trx.bookedThrough]">{{ trx.bookedThrough }}</span>
            </div>
          </div>
          <div class="status">
            <span v-bind:class="['status-label', trx.statusLabel]">{{ trx.statusLabel }}</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Provider ID: </div>
          <div class="value"><a v-bind:href="'/#/provider/' + trx.providerId" target="_blank">{{ trx.providerId }}</a></div>
        </div>
        <div class="title">
          <div class="label">Company: </div>
          <div class="value">{{ trx.company }}</div>
        </div>
        <div class="title">
          <div class="label">RSVP ID: </div>
          <div class="value">
            <a v-bind:href="'/#/reservation/' + trx.rsvpId" target="_blank" v-if="trx.rsvpId !== 0">{{ trx.rsvpId }}</a>
            <a v-bind:href="'/#/package/' + trx.pkgId" target="_blank" v-else>
              {{ trx.pkgId }} <i class="fa fa-cube"></i>
            </a>
          </div>
        </div>
        <div class="title">
          <div class="label">Invoice ID: </div>
          <div class="value">
            <span v-if="trx.trxId !== '0'">{{ trx.trxId }}</span>
            <span v-else>--</span>
          </div>
        </div>
        <div class="title">
          <div class="label">Credit Card: </div>
          <div class="value">{{ trx.creditCard }}</div>
        </div>
        <div class="title">
          <div class="label">Final Offer: </div>
          <div class="value">{{ trx.finalOffer }}</div>
        </div>
        <div class="title">
          <div class="label">Charged Amount: </div>
          <div class="value">{{ trx.chargedAmount }}</div>
        </div>
        <div class="title">
          <div class="label">Promo Used: </div>
          <div class="value">{{ trx.promoUsed }}</div>
        </div>
      </div>
    </div>

    <div class="fix-footer" v-show="transactions.length > 0">
      <div class="row">
        <div class="small-4 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-5 columns page-data">
          <span v-show="transactions.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i" :key="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiTransactions from '@/modules/api/corporate/transactions'

export default {
  name: 'transaction-list',
  props: ['isMobile'],
  data () {
    return {
      sort: {
        active: 'created',
        isDesc: true
      },
      is2lines: false
    }
  },
  computed: {
    conId () { return this.$store.state.corporate.profile.info.consId },
    transactions () { return this.$store.state.corporate.transactions.list },
    loading () { return this.$store.state.corporate.transactions.loading },
    perPage: {
      get: function () { return this.$store.state.corporate.transactions.perPage },
      set: function (value) {
        this.$store.commit('corporate/setTrxPerPage', parseInt(value))
        this.$store.commit('corporate/setTrxCurrentPage', 1)
        this.getTransactions()
      }
    },
    pageData () {
      let tableData = this.$store.state.corporate.transactions
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.$store.state.corporate.transactions.currentPage },
      set: function (value) {
        this.$store.commit('corporate/setTrxCurrentPage', parseInt(value))
        this.getTransactions()
      }
    },
    isLastPage () {
      let tableData = this.$store.state.corporate.transactions
      return (tableData.currentPage * tableData.perPage) >= tableData.maxList
    },
    totalPage () {
      let tableData = this.$store.state.corporate.transactions
      return Math.ceil(tableData.maxList / tableData.perPage)
    }
  },
  methods: {
    getTransactions () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('corporate/resetTransactions')
      self.$store.commit('corporate/setTrxLoading', true)
      ApiTransactions.getTransactions(self, self.conId, function () {
        self.$store.commit('corporate/setTrxLoading', false)
      })
    },
    sortTable (code) {
      if (!code) { return }

      if (this.sort.active === code) { this.sort.isDesc = !this.sort.isDesc }
      else { this.sort.isDesc = true }

      this.sort.active = code
      this.$store.commit('corporate/setTrxSortColumn', code)
      this.$store.commit('corporate/setTrxSortIsDesc', this.sort.isDesc)
      this.$store.commit('corporate/setTrxCurrentPage', 1)
      this.getTransactions(true)
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('corporate/setTrxCurrentPage', this.$store.state.corporate.transactions.currentPage - 1)
      this.getTransactions()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('corporate/setTrxCurrentPage', this.$store.state.corporate.transactions.currentPage + 1)
      this.getTransactions()
    },
    checkScreenSize () { this.is2lines = document.documentElement.clientWidth <= 1507 }
  },
  watch: {
  },
  mounted () {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style lang="scss" scoped>
.trx-list{
  position: relative;
}
.sticky{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 44px;
  z-index: 3;

  .scroll-table::-webkit-scrollbar { visibility: hidden; }
  tbody{ visibility: hidden; }
}

.scroll-table{
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  max-height: calc(100vh - 240px);

  &.two-line-filter{
    max-height: calc(100vh - 285px);
  }
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{
      padding: 5px 10px;

      &:last-child{ cursor: default; }
      i{ display: none; }
      & i.stripe-icon { display: inline; }
      .fa-sort-up{ vertical-align: -2px; }
      .fa-sort-down{ vertical-align: 2px; }
      &.sortable{
        cursor: pointer;
        color: #333;
        span{
          font-weight: 600;
          text-decoration: underline;
        }
      }
      &.sort i{ display: inline-block; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:nth-child(even) { background: #f3f3f3; }
      &:hover { background: #d7dbe4; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        color: #555;

        &.status, &.bookedThrough{ font-weight: 600; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
        a{
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}

.rsvp-type{
  text-transform: uppercase;
  padding: 3px 5px;
  color: #fff;
  border-radius: 4px;

  &.rsvp{ background: #5771d0; }
  &.asap{ background: #d05757; }
  &.package{ background: #26d97a; }
}

.booked-label{
  padding: 3px 5px;
  background: #ccc;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;

  &.Web{ background: #a26d5d; }
  &.Admin{ background: #2b83f1; }
  &.Android{ background: #78c259; }
  &.iOS{ background: #7fc8de; }
  &.CSR{ background: #bb4a91; }
  &.Provider{ background: #3f3f3f; }
}

.status-label{
  line-height: 1;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 11px!important;
  background: #999;
  display: inline-block;

  &.Purchased, &.Purchase{ background: #4aadf3; }
  &.Completed{ background: #26D97A; }
  &.Promo{ background: #f3904a; }
  &.Edited, &.Refund{ background: #797979; }
  &.No.Show, &.Cancelled, &.Declined{ background: #f54f4f; }
  &.Pending.Refund{
    background: #098769;
    color: #fff;
  }
  &.NOT_PROCESSED{
    background: #FFCC00 !important;
    color: #505050 !important;
  }
}

.fix-footer{
  width: 100%;
  height: 60px;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;

    &.prev-next{ text-align: center; }

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .rsvp-type {
    font-size: 12px;
    margin-right: 5px;
  }
  .fix-footer {
    .row {
      display: flex;
      justify-content: space-between;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      padding: 15px 0px;

      select {
        width: 55px;
      }
    }
  }

  .loader, .empty-result {
    text-align: center;
    padding: 50px 0;
  }

  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      display: flex;
      flex-direction: column;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
        width: 100%;
      }

      .email-logo {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    
        .time {
          font-size: 12px;
          color: #777;
          word-spacing: 5px;
        }

        .amount {
          font-weight: 900;
          font-size: 20px;
          a {
            text-decoration: none;
          }
        }
      }

      .credit-card {
        font-weight: 900;
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;

        &.pkg-div {
          justify-content: space-between;
        }

        .pkg-type {
          display: flex;
        }

        input {
          margin-right: 5px;
        }

        &.view {
          justify-content: space-between;
          padding-top: 7px;
          padding-bottom: 5px;
          border-top: 1px solid #eee;
        }

        .refer {
          display: flex;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/TransactionList.vue